// extracted by mini-css-extract-plugin
export var SlideContainer = "style-module--SlideContainer--3trB3";